import { useState } from 'react';
import { BlobServiceClient } from '@azure/storage-blob';
import { v4 as uuidv4 } from 'uuid';

// Configuración de Azure
const accountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME || "farostorage";
const sasToken = process.env.REACT_APP_AZURE_STORAGE_SASTOKEN ;
const containerName = process.env.REACT_APP_AZURE_CONTAINER_NAME || "asn-buckets";

const blobServiceClient = new BlobServiceClient(
  `https://${accountName}.blob.core.windows.net/?${sasToken}`
);

const useBlobUploader = () => {
  const [file, setFile] = useState(null);

  const selectFile = (selectedFile) => {
    setFile(selectedFile);
  };

  const uploadFile = async (fileToUpload, onSuccess, onError) => {
    // Usar el archivo pasado como parámetro o el archivo del estado
    const fileToProcess = fileToUpload || file;
    
    if (!fileToProcess) {
      if (onError) onError("No se ha seleccionado un archivo.");
      return;
    }

    try {
      const containerClient = blobServiceClient.getContainerClient(containerName);

      const newFileName = `asn_attachments/${uuidv4()}-${fileToProcess.name}`;
      const blobClient = containerClient.getBlockBlobClient(newFileName);
      await blobClient.uploadBrowserData(fileToProcess);

      const uploadedUrl = blobClient.url;
      if (onSuccess) onSuccess(uploadedUrl);
    } catch (error) {
      console.error("Error al subir el archivo a Azure Blob:", error);
      if (onError) onError(error.message || "Error desconocido");
    }
  };

  return {
    selectFile,
    uploadFile
  };
};

export default useBlobUploader;
